import { jsx as _jsx } from "react/jsx-runtime";
import 'reset-css';
import 'overlayscrollbars/overlayscrollbars.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
require('setimmediate');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(App, {}));
reportWebVitals();
